export const downloadCSV = (csv, filename) => {
  const csvFile = new Blob([csv], { type: "text/csv" });
  const downloadLink = document.createElement("a");
  // sets the name for the download file

  downloadLink.download = `${filename ? filename : "test"}.csv`;
  // sets the url to the window URL created from csv file above
  downloadLink.href = window.URL.createObjectURL(csvFile);
  // creates link, but does not display it.
  downloadLink.style.display = "none";
  // add link to body so click function below works
  document.body.appendChild(downloadLink);

  downloadLink.click();
};
